/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  SitemapControllerGetSitemapManifestQueryResponse,
  SitemapControllerGetSitemapManifestHeaderParams,
  SitemapControllerGetSitemapManifest404,
  SitemapControllerGetSitemapManifest503,
} from '../../types/SitemapControllerGetSitemapManifest.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { sitemapGetSitemapManifest } from '../../methods/sitemapGetSitemapManifest.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const sitemapGetSitemapManifestQueryKey = () => [{ url: '/api/sitemap/manifest' }] as const;

export type SitemapGetSitemapManifestQueryKey = ReturnType<typeof sitemapGetSitemapManifestQueryKey>;

export function sitemapGetSitemapManifestQueryOptions(
  headers?: SitemapControllerGetSitemapManifestHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = sitemapGetSitemapManifestQueryKey();
  return queryOptions<
    SitemapControllerGetSitemapManifestQueryResponse,
    ResponseErrorConfig<SitemapControllerGetSitemapManifest404 | SitemapControllerGetSitemapManifest503>,
    SitemapControllerGetSitemapManifestQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return sitemapGetSitemapManifest(headers, config);
    },
  });
}

/**
 * @summary Get the published sitemap manifest for the current website.
 * {@link /api/sitemap/manifest}
 */
export function useSitemapGetSitemapManifest<
  TData = SitemapControllerGetSitemapManifestQueryResponse,
  TQueryData = SitemapControllerGetSitemapManifestQueryResponse,
  TQueryKey extends QueryKey = SitemapGetSitemapManifestQueryKey,
>(
  headers?: SitemapControllerGetSitemapManifestHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        SitemapControllerGetSitemapManifestQueryResponse,
        ResponseErrorConfig<SitemapControllerGetSitemapManifest404 | SitemapControllerGetSitemapManifest503>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? sitemapGetSitemapManifestQueryKey();

  const query = useQuery(
    {
      ...sitemapGetSitemapManifestQueryOptions(headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<SitemapControllerGetSitemapManifest404 | SitemapControllerGetSitemapManifest503>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
